import React, { memo } from "react";
import "./TagDetails.scss";

interface ITagDetails {
  tag: string;
  description?: string;
  hasResults: boolean;
}

export const TagDetails: React.FC<ITagDetails> = memo(({
  tag,
  description,
  hasResults
}) => {
  const title = hasResults
    ? <><span className="capitalized">{tag}</span> Porn GIFs, Niches, Creators & More</>
    : <>Oh No! We were unable to find any results for <span>{tag}</span></>;

  const defaultDescription = (
    <>
      We're currently improving our search algorithm, so you'll be less likely to run into this issue in the future.
      In the meantime, is there another word to describe what you're looking for?
    </>
  );

  return (
    <div className="TagDetails">
      <h1 className="TagDetails-Title">{title}</h1>
      <p className="TagDetails-Description">{hasResults ? description : defaultDescription}</p>
    </div>
  );
});
